import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import endPoints from 'config/routes/endpoints';
import List from 'widgets/List';
import Drawer from 'widgets/Drawer';
import Sidebar from 'components/Sidebar';
import Icon from 'components/Icon';
import SelectableList from 'components/SelectableList';
import colors from 'assets/styles/jsVariables/colors';
import { removeCssClass, hasSubscription, hasMembership } from 'libs/common';
import { applyFixToWindowPosition, applyRelativeToWindowPosition } from 'libs/windowDimension';
import styles from './styles';
import './SideBar.scss';

const navList = [
  {
    url: endPoints.subscriptions,
    text: <FormattedMessage id="views.headerAndSidebarLayout.sidebar.navList.item1" />,
    icon: 'star'
  },
  {
    url: endPoints.accountSetting,
    text: <FormattedMessage id="views.headerAndSidebarLayout.sidebar.navList.item2" />,
    icon: 'gear'
  },
  {
    url: endPoints.dataPolicy,
    text: <FormattedMessage id="views.headerAndSidebarLayout.sidebar.navList.item3" />,
    icon: 'lock'
  },
  {
    url: endPoints.memberships,
    text: <FormattedMessage id="views.headerAndSidebarLayout.sidebar.navList.item4" />,
    icon: 'star'
  },
  {
    url: endPoints.communicationPreferences,
    text: <FormattedMessage id="views.headerAndSidebarLayout.sidebar.navList.item5" />,
    icon: 'email-icon'
  },
];

function navListIndexOf(url) {
  return _.findIndex(navList, item => (
    _.indexOf(item.matchUrl, url) > -1 ||
    item.url === url
  ));
}

const styleClasses = {
  DrawerStyle: {
    width: window.innerWidth <= 480 ? window.innerWidth : 242,
    overflow: 'hidden'
  },
  ListItemStyle: {
    '&:hover': {
      backgroundColor: colors.white,
    }
  }
};

export class SideBarComponent extends Component {
  static getDerivedStateFromProps(props) {
    const { open } = props;
    if (
      open
    ) {
      applyFixToWindowPosition();
    } else {
      applyRelativeToWindowPosition();
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {};
    this.isSubscribed = false;
    this.isMembership = false;
  }

  handleNavClick = (url) => {
    const { open } = this.props;
    if (open) {
      this.props.closeSideBar();
    }
    window.appHistory.push(url);
  }

  handleMouseEnter = (e) => {
    removeCssClass('Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar');

    if (e.target.firstElementChild) {
      e.target.firstElementChild.classList.add('Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar');
    }
  }

  handleMouseLeave = () => {
    removeCssClass('Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar');

    const element = document.getElementById('Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar');
    if (element) {
      element.classList.add('Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar');
    }
  }

  navListItem = (index, currentRoute) => {
    const selected = index === navListIndexOf(currentRoute);

    return (
      <List
        type="listItem"
        button
        onClick={() => this.handleNavClick(navList[index].url)}
        style={{
          ...styles.listItem,
          ...(selected ? styles.selectedListItem : null)
        }}
        cssStyles={{
          root: styleClasses.ListItemStyle
        }}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <React.Fragment>
          <div
            id={selected ? 'Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar' : ''}
            className={selected ? 'Layout__HeaderAndSidebar__Sidebar__ItemSelectedBar' : ''}
          />
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Icon name={navList[index].icon} style={{ width: '16px', height: '16px' }} fill={selected ? '#4a4a4a' : '#a8a8a8'} />
          </div>
          <div style={{ display: 'inline-block', marginLeft: '7px' }}>
            {navList[index].text}
          </div>
        </React.Fragment>
      </List>
    );
  }

  renderSidebarContent = () => {
    const { location: { location: { pathname } } } = this.props;
    const currentRoute = pathname ? `/${pathname.split('/')[1]}` : `/${window.appHistory.location.pathname.split('/')[1]}`;

    this.isSubscribed = hasSubscription(this.props.userSubscriptions);
    this.isMembership = hasMembership(this.props.userSubscriptions);

    return ([
      <SelectableList
        key={0}
        style={{ marginLeft: -18, paddingTop: '32px', position: 'static' }}
      >
        {this.isSubscribed && this.navListItem(this.isMembership ? 3 : 0, currentRoute)}
        {this.navListItem(1, currentRoute)}
        {this.navListItem(2, currentRoute)}
        {this.navListItem(4, currentRoute)}
        <div className="Layout__HeaderAndSidebar__Sidebar__HelpText">
          <FormattedMessage id="views.headerAndSidebarLayout.sidebar.description" />
          <a className="hyperLink" href="https://choosemuse.com/contactsupport">
            <FormattedMessage id="views.headerAndSidebarLayout.sidebar.customerCare" />
          </a>.
        </div>
      </SelectableList>
    ]);
  }

  render() {
    const {
      open, closeSideBar
    } = this.props;

    return (
      <React.Fragment>
        <Sidebar
          className="noPrintAccountLayout"
        >
          {this.renderSidebarContent()}
        </Sidebar>
        <Drawer
          className="Layout__HeaderAndSidebar__SidebarDrawer--List"
          open={open}
          onClose={closeSideBar}
          PaperProps={{
            style: styles.drawer
          }}
          cssStyles={{
            paper: styleClasses.DrawerStyle
          }}
          ModalProps={{
            style: {
              position: 'absolute'
            },
            BackdropProps: {
              style: {
                opacity: 0
              }
            }
          }}
        >
          {this.renderSidebarContent()}
        </Drawer>
      </React.Fragment>
    );
  }
}

SideBarComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  closeSideBar: PropTypes.func.isRequired,
  userSubscriptions: PropTypes.array.isRequired
};

function mapStateToProps({ windowLocation, auth }) {
  return {
    location: windowLocation,
    userSubscriptions: (auth.info && auth.info.subscriptions) || []
  };
}

export default connect(mapStateToProps)(SideBarComponent);



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderAndSidebarLayout/SideBar/SideBar.jsx